export default {
  checkLoading: (state) => (method, route) => {
    if (method && route) {
      return state.loading[method].includes(route)
    }
    return Object.keys(state.loading).some((key) => {
      return state.loading[key].length > 0
    })
  },
  checkSkeleton: (state) => () => {
    return Object.keys(state.skeleton).some((key) => {
      return state.skeleton[key].length > 0
    })
  },
  getMotd(state) {
    return state.motd
  },
  getProgress: (state) => (type) => {
    return state.progress[type] || 0
  },
  getLastActivity(state) {
    return state.lastActivity
  },
  getServiceNotAvailable(state) {
    return state.serviceNotAvailable
  },
  getFilterStatus: (state) => (list) => {
    return state.filterStatus[list.name]
  },
  getFilterHeaders: (state) => (list) => {
    return state.filterHeaders[list.name]
  },
  getFilterList: (state) => (list) => {
    return state.filterList[list.name || list]
  },
  checkDeleteSearch: (state) => (list) => {
    return !state.deleteSearch.includes(list.name)
  },
  checkDialog: (state) => (name) => {
    return state.dialog === name && !state.minimized
  },
  getCorrectionDialogRequest(state) {
    return state.correctionDialog.request
  },
  getCorrectionDialogForm(state) {
    return state.correctionDialog.form
  },
  getCorrectionDialogKey(state) {
    return state.correctionDialog.key
  },
  getCorrectionDialogChange(state) {
    return state.correctionDialog.change
  },
  getCorrectionDialogPrev(state) {
    return state.correctionDialog.prev
  }
}
